import { ImageFields, ImagePreset, Images } from 'types/photo';
import { ParamsStoryForForm, Story, StoryPlatform } from 'types/story';

export enum STORIES_TAB_VALUES {
  INFO = 'info',
  STYLING = 'styling',
  STORIES = 'stories',
}

export type CreateStoryFormValuesProps = ParamsStoryForForm;
export type EditStoryFormValuesProps = Story;

export const STORY_PLATFORM_OPTIONS = [
  { value: StoryPlatform.ANDROID, label: 'Android' },
  { value: StoryPlatform.HUAWEI, label: 'Huawei' },
  { value: StoryPlatform.IOS, label: 'iOS' },
  { value: StoryPlatform.WEB_DESKTOP, label: 'Web desktop' },
  { value: StoryPlatform.WEB_MOBILE, label: 'Web mobile' },
];

export const STORY_IMAGES_PRESETS: Record<keyof Images, ImagePreset> = {
  [ImageFields.MOBILE]: {
    width: 160,
    height: 160,
    title: 'Мобильная версия',
    rounded: true,
  },
  [ImageFields.DESKTOP]: {
    width: 160,
    height: 160,
    title: 'ПК версия',
    rounded: true,
  },
};
